import { render } from "./castellDelRemei.vue?vue&type=template&id=8a8d652c"
import script from "./castellDelRemei.vue?vue&type=script&lang=js"
export * from "./castellDelRemei.vue?vue&type=script&lang=js"

import "./castellDelRemei.vue?vue&type=style&index=0&id=8a8d652c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__